import React, { useState, useEffect} from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import styles from './Admin.module.css'

import { getSpecies } from '../../actions/actions'

import Form from './Form/Form'
import List from './List/List'

const Admin = () => {

    const dispatch = useDispatch()
    const [currentId, setCurrentId] = useState(null)

    const history = useHistory()
    const location = useLocation()
   
    //Retrieve user details from local storage
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))

    useEffect(()=> {

        setUser(JSON.parse(localStorage.getItem('profile')))
    }, [location]) 

    console.log(user.result.role)
    //Fetch species from database
    useEffect(()=> {
        dispatch(getSpecies())
      }, [currentId, dispatch])

    return (
        <div>
            <div>
                {
                    (user.result?.role !== 'admin') ? (<div className={styles.pageContainer} >(<div>{history.push('/')}</div>)</div>) :
                    (
                    <div className={styles.pageContainer}>
                        <List currentId={currentId} setCurrentId={setCurrentId} />
                        <Form currentId={currentId} setCurrentId={setCurrentId} />
                    </div>
                    )
                }
            </div>
            
        </div>

            


    

    )
}

export default Admin
